const SCROLL_LOCKED_CLASS = 'scroll-locked';
const getLockElement = ()=>typeof document === 'undefined' ? null : document.body || null
;
const isScrollLocked = (lockElement)=>{
    const element = lockElement || getLockElement();
    return element ? element.classList.contains(SCROLL_LOCKED_CLASS) : false;
};
const getScrollY = (scrollElement)=>{
    if (!scrollElement && typeof window === 'undefined') {
        return 0;
    }
    return scrollElement ? scrollElement.scrollTop : window.pageYOffset;
};
const setScrollY = (position, scrollElement)=>{
    if (!scrollElement && typeof window === 'undefined') {
        return;
    }
    if (scrollElement) {
        scrollElement.scrollTop = position;
    } else {
        // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollTo#parameters
        // 'instant' is a valid parameter and it's working but TS was complaining -\_/-
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.scrollTo({
            left: window.pageXOffset,
            top: position,
            behavior: 'instant'
        });
    }
};
const lockScroll = (position, scrollElement, lockElement)=>{
    const scrollY = position || getScrollY(scrollElement);
    const element = lockElement || getLockElement();
    if (!element) {
        return;
    }
    element.classList.add(SCROLL_LOCKED_CLASS);
    element.style.overflowY = 'hidden';
    element.style.position = 'fixed';
    element.style.top = `-${scrollY}px`;
};
const unlockScroll = (position, scrollElement, lockElement)=>{
    const element = lockElement || getLockElement();
    if (element === null) {
        return;
    }
    const top = position ? undefined : element.style.top;
    const scrollY = top ? Math.abs(parseInt(top, 10)) : position || 0;
    let requestID;
    let frameTickCount = 0;
    const resetStyling = ()=>{
        element.classList.remove(SCROLL_LOCKED_CLASS);
        element.style.overflowY = '';
        element.style.position = '';
        resetTopStyling();
    };
    const resetTopStyling = ()=>{
        const removeTopStyling = ()=>{
            if (// Check if all the related initial `scroll-lock styling' has been removed
            !element.classList.contains(SCROLL_LOCKED_CLASS) && !element.style.overflowY && !element.style.position) {
                // Only remove the top styling when the `frameTickCount is 2 or greater`, because if it is lower than 2, the body element scrolls back to the top of the page
                if (frameTickCount >= 2) {
                    element.style.top = '';
                    cancelAnimationFrame(requestID);
                } else {
                    // Only start to increase the frameTickCount after the related  initial `scroll-lock styling' has been removed
                    ++frameTickCount;
                    requestID = requestAnimationFrame(removeTopStyling);
                }
            }
        };
        // Added a `requestAnimationFrame` for removing the `top` css property,
        // which prevents the body element from unnecessary scrolling to the top of the page
        requestID = requestAnimationFrame(removeTopStyling);
    };
    resetStyling();
    setScrollY(scrollY, scrollElement);
};

export { SCROLL_LOCKED_CLASS, getScrollY, isScrollLocked, lockScroll, setScrollY, unlockScroll };
//# sourceMappingURL=scroll-lock.js.map
